import {
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    IconButton,
} from "@mui/material";
import { useState } from "react";
import { useLogout } from "../shared/hooks/useUser";

const LogoutButton = ({ icon }) => {
    const logoutMutation = useLogout();

    const [confirmationOpen, setConfermationOpen] = useState(false);

    const handleLogout = () => {
        logoutMutation.mutate(
            {},
            {
                onSuccess: () => {
                    localStorage.removeItem("frappUser");
                    localStorage.removeItem("accessToken");
                    localStorage.removeItem("user");
                    localStorage.removeItem("token");
                    localStorage.setItem("loggedIn", "false");
                    // Force immediate redirect to login (no manual refresh needed)
                    window.location.href = "/login";
                },
            }
        );
    };

    return (
        <>
            {icon ? (
                <IconButton onClick={() => setConfermationOpen(true)}>
                    <Button>Log out</Button>
                    {icon}
                </IconButton>
            ) : (
                <Button onClick={() => setConfermationOpen(true)}>
                    Log out
                </Button>
            )}

            <Dialog
                open={confirmationOpen}
                onClose={() => setConfermationOpen(false)}
            >
                <DialogTitle id="alert-dialog-title">
                    Are you shure you want to Log Out ?
                </DialogTitle>
                <DialogActions>
                    <Button onClick={() => setConfermationOpen(false)}>
                        Cancel
                    </Button>
                    <Button onClick={handleLogout}>Confirm</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default LogoutButton;
